import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getOptions = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier_report.options;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCurrencies = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier_report.currencies;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getReport = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier_report.generate_report;

  const sendData = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(sendData))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

// const setDownload = (data: any) => {
//   const authenticity_token = getCookie(cookieToken);
//
//   const endpoint = api.admin.cashier_report.download_report;
//
//   const payload = {
//     ...data.payload,
//     authenticity_token: authenticity_token,
//   };
//
//   return fetch(
//     `${endpoint}`,
//     {...RequestOptions('POST', JSON.stringify(payload))}
//   )
//     .then(handleResponse)
//     .then(
//       data => {
//         return data;
//       }
//     )
//     .catch((error) => {
//       return error
//     });
// };

// const getAgents = (data: any) => {
//   const authenticity_token = getCookie(cookieToken);
//
//   const endpoint = api.admin.cashier_report.agents;
//
//   const payload = {
//     ...data,
//     authenticity_token: authenticity_token,
//   };
//
//   return fetch(
//     `${endpoint}`,
//     {...RequestOptions('POST', JSON.stringify(payload))}
//   )
//     .then(handleResponse)
//     .then(
//       data => {
//         return data;
//       }
//     )
//     .catch((error) => {
//       return error
//     });
// };

export const agentStatisticReportService = {
  getOptions,
  getReport,
  getCurrencies,
};
